import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fullRefundRadio", "partialRefundRadio", "partialAmountContainer", "amountInput"]

  connect() {
    this.toggleRefundType()
  }

  toggleRefundType() {
    if (this.partialRefundRadioTarget.checked) {
      this.partialAmountContainerTarget.classList.remove("hidden")
      this.amountInputTarget.required = true
    } else {
      this.partialAmountContainerTarget.classList.add("hidden")
      this.amountInputTarget.required = false
      // Reset to full amount when switching to full refund
      const fullAmount = this.amountInputTarget.max
      this.amountInputTarget.value = fullAmount
    }
  }
}